<template>
  <!-- "Keyboard shortcuts" (the ? key): only the web's own keys (SI-5). -->
  <SheetModal v-model="open" title="Keyboard shortcuts" :width="420">
    <div class="keys">
      <section v-for="g in groups" :key="g.header" class="keys-group" :aria-label="g.header">
        <h3 class="keys-head">{{ g.header }}</h3>
        <dl class="keys-list">
          <div v-for="k in g.rows" :key="k.label" class="keys-row">
            <dt>{{ k.label }}</dt>
            <dd><kbd v-for="part in k.keys" :key="part">{{ part }}</kbd></dd>
          </div>
        </dl>
      </section>
    </div>
  </SheetModal>
</template>

<script>
import SheetModal from "@/components/kit/SheetModal.vue";
import { isMac } from "./shortcuts.js";
import { shortcutGroups } from "./shortcutList.js";

export default {
  name: "ShortcutsSheet",
  components: { SheetModal },
  props: {
    modelValue: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  computed: {
    open: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit("update:modelValue", v);
      },
    },
    // Every key the web binds, grouped as the app's sheet (shortcutList.js).
    groups() {
      return shortcutGroups({ mac: isMac() });
    },
  },
};
</script>

<style scoped>
.keys {
  margin: 0;
  /* SheetModal's body already pads the sides (20, 16 on phones): the rows
     line up with the title. */
  padding: 8px 0 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
/* The app's ClListGroup header over each group. */
.keys-head {
  margin: 0 0 8px;
  font: 600 12px/16px var(--cl-font);
  color: var(--cl-label-2);
}
.keys-list {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.keys-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  font: 400 13px/18px var(--cl-font);
  color: var(--cl-label);
}
.keys-row dd {
  margin: 0;
  display: flex;
  gap: 4px;
}
kbd {
  min-width: 22px;
  padding: 1px 6px;
  border-radius: 4px;
  border: 1px solid var(--cl-border-default);
  font: 400 12px/18px var(--cl-font-mono);
  color: var(--cl-label-2);
  text-align: center;
}
</style>
